export interface IBenefit {
	id: number;
	name: string;
	type: string;
	percentage: number;
	description: string | null;
	isActive: boolean;
	startDate: Date;
	expirationDate: Date;
	createdAt: Date;
	updatedAt: Date;
	deletedAt: Date;
}

export interface ICompanyBenefit {
	id: number;
	name: string;
	type: string;
	description: string | null;
	isActive: boolean;
	createdAt: Date;
	createdBy: string;
}

export enum BenefitType {
	PAYMENT = 'Payment',
	CONVERT = 'Convert',
	PLAN = 'Plan',
}
export const benefitTypes = [{ value: 'Convert', label: 'page.benefits_management.convert', disabled: false }];
